export const getOptionCSSClass = (option) => {
  if (option.notAvailable) {
    return "cs-not-available"
  } else if (option.disabled) {
    return "cs-disabled"
  } else {
    return ""
  }
}

export const filterOptions = (options, nameFn, searchString) => {
  if (!searchString || searchString.length === 0) return options

  const lowerCaseSearch = searchString.toLowerCase()
  const filteredMatches = []

  OPT_LOOP: for (const option of options) {
    if (nameFn(option).toLowerCase().indexOf(lowerCaseSearch) >= 0) {
      filteredMatches.push(option)
      continue
    }

    if (option.description) {
      if (option.description.toLowerCase().indexOf(lowerCaseSearch) >= 0) {
        filteredMatches.push({
          ...option,
          matchExplanation: option.description,
        })
        continue
      }
    }

    let extraKeywords = []
    Object.values(option.dcs_logging_info || {}).forEach((d) => {
      if (Array.isArray(d)) {
        extraKeywords = [...extraKeywords, ...d]
      } else {
        extraKeywords.push(d)
      }
    })

    const finalKeywords = [...(option.keywords || []), ...extraKeywords]
    if (finalKeywords) {
      for (const k of finalKeywords) {
        if (k.toLowerCase().indexOf(lowerCaseSearch) >= 0) {
          filteredMatches.push({
            ...option,
            matchExplanation: k,
          })
          continue OPT_LOOP
        }
      }
    }
  }

  return filteredMatches
}

export const toggleExpandedCategory = (selected_cat, collapse_status, expanded_cat) => {
  const updatedState = {}

  if (expanded_cat !== selected_cat) {
    updatedState["expanded"] = selected_cat
  }

  if (updatedState["expanded"] && !collapse_status) {
    updatedState["collapse"] = false
  } else {
    updatedState["collapse"] = !collapse_status
  }

  return updatedState
}
